export const formatObject = (object, cartId) => {
    return {
        "id": cartId,
        "barcode": object.value,
        "description": object.label,
    }
};